import { legalDocuments } from '@/shared/legal/documents';

interface Props {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}

export default function LegalAcceptance({ id, checked, onChange, error }: Props) {
  return (
    <div className="rounded-xl border border-teal-200 bg-teal-50/50 p-4 text-sm text-gray-800">
      <label htmlFor={id} className="flex cursor-pointer items-start gap-3">
        <input id={id} type="checkbox" required checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined}
          className="mt-1 h-5 w-5 shrink-0 accent-[#1A8C7A]" />
        <span>{legalDocuments.acceptance}</span>
      </label>
      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-2 pl-8">
        <a href="/conditions-utilisation" target="_blank" rel="noopener noreferrer" className="font-semibold text-teal-800 underline">Lire les conditions (nouvel onglet)</a>
        <a href="/confidentialite" target="_blank" rel="noopener noreferrer" className="font-semibold text-teal-800 underline">Lire la confidentialité (nouvel onglet)</a>
      </div>
      {error && <p id={`${id}-error`} role="alert" className="mt-2 text-red-700">{error}</p>}
    </div>
  );
}
